import { OnBoardFormData } from 'containers/authorised/ATS/organisms/OnBoardForm'

export const CREATE_ON_BOARD_FORM = 'CREATE_ON_BOARD_FORM'
export const CREATE_ON_BOARD_FORM_PENDING = 'CREATE_ON_BOARD_FORM_PENDING'
export const CREATE_ON_BOARD_FORM_FULFILLED = 'CREATE_ON_BOARD_FORM_FULFILLED'
export const CREATE_ON_BOARD_FORM_REJECTED = 'CREATE_ON_BOARD_FORM_REJECTED'

export type ATSQuestionnairRequest = {
  ats_questionnaire: OnBoardFormData
}
